import React from 'react';
import moment from 'moment';
import { Typography } from "@material-ui/core";
import ReactSelect from '../../../../../common/components/UI/Select/ReactSelect';
import { ShiftSegmentType } from '../../../../Enums';
import './SetSkillAndCertificationProfiles.scss';
import DateFormatService from '../../../../../WorkplanManager/services/DateFormatService';
import { UkgDateFormat } from '../../../../../WorkplanManager/Enums';

const SetSkillAndCertificationProfiles = ({
    t,
    skillAndCertificationProfiles,
    shift,
    shiftlineJob,
    shiftSegments,
    onValueChange
}) => {
    const shiftStartTime = moment(shift.startDateTime);
    const shiftEndTime = moment(shift.endDateTime);
    const shiftDuration = shiftEndTime.diff(shiftStartTime, 'hours', true);
    const shiftDurationHour = `${shiftDuration.toString().split('.')[0]}`;
    const minutesMulitplier = `0.${shiftDuration.toString().split('.')[1]}`;
    const shiftDurationMinutes = Math.round(Number(minutesMulitplier) * 60);
    const shiftDurationMinutesFormatted = shiftDurationMinutes < 10 ? `0${shiftDurationMinutes}` : shiftDurationMinutes.toString();
    const shiftDurationFormatted =`${shiftDurationHour}:${shiftDurationMinutesFormatted}`;

    return (
        <div className="set-skill-and-certification-profiles-container">
            <Typography className="title">
                {DateFormatService.formatPeriod(shift.startDateTime, shift.endDateTime, UkgDateFormat.TimeFormat) + " (" + shiftDurationFormatted + ")"}
            </Typography>
            <Typography className="segments-title">
                {t('workPlan.shift.segments.name')}
            </Typography>
            <hr></hr>
            {shiftSegments.map((segment, index) => {
                    const indexSegment = index + 1;
                    const segmentStartTime = moment(segment.startDateTime);
                    const segmentEndTime = moment(segment.endDateTime);
                    const segmentDurationHour = moment(segmentEndTime.diff(segmentStartTime, 'hours', true));
                    const segmentDurationMinutesFull = moment(segmentEndTime.diff(segmentStartTime, 'minutes', true));
                    const segmentDurationMinutes = segmentDurationMinutesFull % 60;
                    const segmentDurationMinutesAdjusted = segmentDurationMinutes < 10 ? `0${segmentDurationMinutes}` : segmentDurationMinutes.toString();
                    const job = segment.orgNode ? segment.orgNode.qualifier : shiftlineJob.label;
                    
                    let segmentType = '';
                    switch (segment.segmentType.id) {
                        case ShiftSegmentType.Regular:
                            segmentType = t('workPlan.shift.segments.type.regular');
                            break;
                        case ShiftSegmentType.Transfer:
                            segmentType = t('workPlan.shift.segments.type.transfer');
                            break;
                        case ShiftSegmentType.Break:
                            segmentType = t('workPlan.shift.segments.type.break');
                            break;
                        default:
                            segmentType = '';
                            break;
                    }

                    return (
                        <>
                            <Typography className="segment-title">
                                {indexSegment + '.  ' + DateFormatService.formatPeriod(segment.startDateTime, segment.endDateTime, UkgDateFormat.TimeFormat)  
                                + " [" + segmentDurationHour + ":" + segmentDurationMinutesAdjusted + "]: " + segmentType}
                            </Typography>
                            <div className="segment-container">
                                <Typography>
                                    {job}
                                </Typography>
                                {segment.segmentType.id !== ShiftSegmentType.Break && (
                                    <>
                                        <Typography className="skill-and-certification-profiles-title">
                                            {t('workPlan.shift.segments.skillAndCertificationProfiles')}
                                        </Typography>
                                        <ReactSelect
                                            placeholder={t('workPlan.selectSkillAndCertificationProfilesPlaceholder')}
                                            value={segment.segmentSCProfiles}
                                            options={skillAndCertificationProfiles}
                                            onChange={(event, value) => onValueChange(value, index)}
                                            isMulti={true}
                                        />
                                    </>
                                )}
                            </div>
                        </>
                    );
            })}
        </div>
    );
};

export default SetSkillAndCertificationProfiles;
